import axios from "@/libs/api.request";

export const WebGetCase = data => {
  return axios.request({
    url: "/site/admin/case",
    method: "get",
    params: data
  });
};

export const WebSaveCase = data => {
  return axios.request({
    url: "/site/admin/case",
    data,
    method: "post"
  });
};

export const ImagesUpload = data => {
  return axios.request({
    url: "/site/admin/upload",
    data,
    method: "post"
  });
};
